import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import FormField from '@/components/forms/form-field';
import Loader from '@/components/loader';
import api, { setErrors} from '@/middlewares/api';

class ProfileCompanyForm extends Component {
    constructor(props) {
        super(props);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(data) {        
        return new Promise((resolve, reject) => {
            api.post('profile/company', data)
            .then((response) => {
                this.props.updateUserData(response.data.data, 'profile');
                toast.success('Company details saved successfully.');
                return resolve(null);
            })
            .catch((err) => {
                if(! err.response) {
                    toast.error('Network error. Please check your connection and try again.');
                    return reject({ _error: 'Network error. Please check your connection and try again.' });
                }
                if(err.response.status === 422) {
                    toast.error('Please fix the highlighted fields and try again.');
                    return reject(setErrors(err.response));
                }
                const message = err.response.data?.message || 'Could not save changes. Please try again.';
                toast.error(message);
                return reject({ _error: message });
            })
        }); 
    }
    render() {
        const { handleSubmit, submitting, error } = this.props;
        return (
            <React.Fragment>
            <Loader isOpen={ submitting } type="full" />
            <form onSubmit={handleSubmit((data) => {
                return this.handleFormSubmit(data);
            }) } className="profile-form"
            noValidate>
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <div className="form-row">
                <div className="form-col_2">
                    <Field                            
                        name="label_name"
                        component={FormField}                                        
                        type="text"
                        placeholder="Name of your Label"
                        label="Name of your Label"                            
                    />                    
                </div>                                
                <div className="form-col_2">                    
                    <Field                            
                        name="distribution_company"
                        component={FormField}                                        
                        type="text"
                        placeholder="Company Distributing Your Project"
                        label="Company Distributing Your Project"                            
                    />               
                </div>
            </div>
            <div className="form-row">
                <div className="form-col_2">
                    <Field                            
                        name="business_address"
                        component={FormField}                                        
                        type="text"
                        placeholder="Your Business Address"
                        label="Your Business Address"                            
                    />                                
                </div>                                
                <div className="form-col_2"> 
                    <Field                            
                        name="agreement_signer"
                        component={FormField}                                        
                        type="text"
                        placeholder="Who Will Sign Sample Agreements?"
                        label="Who Will Sign Sample Agreements?"                            
                    />                                  
                    
                </div>
            </div>
            <div className="form-row form-row_bottom">
                <div className="form-col_2">
                    <Field                            
                        name="payer_name"
                        component={FormField}                                        
                        type="text"
                        placeholder="Party Responsible For Making Payment?"
                        label="Party Responsible For Making Payment?"                            
                    />                    
                </div>
                <div className="form-col_2">
                    <Field                            
                        name="payer_email"
                        component={FormField}                                        
                        type="email"
                        placeholder="Party Responsible For Making Payment Email?"
                        label="Party Responsible for Making Payment Email?"                            
                    />                    
                </div>
            </div>
            <div className="submit-row">
                <button className="btn btn-primary" disabled={ submitting }
                        type="submit">Save Changes</button>

            </div>
        </form>
        </React.Fragment>
        )
    }
}

const ProfileCompanyFormWrapped =  reduxForm({
    form: 'dashboard-profile-company-form',
    enableReinitialize: true,
  })(ProfileCompanyForm);

ProfileCompanyFormWrapped.propTypes = {
    //...RFPropsTypes,
    updateUserData: PropTypes.func.isRequired,
}  


export default ProfileCompanyFormWrapped;
